module.exports = __webpack_public_path__ + "static/media/certificate-background.ce52cb00.svg";